<ng-container [ngSwitch]="exportType">
  <ap-export-settlement-data *ngSwitchCase="'SETTLEMENT'"></ap-export-settlement-data>
  <ap-export-devices-data *ngSwitchCase="'DEVICES'"></ap-export-devices-data>
  <ap-export-device-alarms-data *ngSwitchCase="'ALARMS'"></ap-export-device-alarms-data>
</ng-container>
